!function(){Array.prototype.find||(Array.prototype.find=function(r){if(null==this)throw new TypeError("Array.prototype.find called on null or undefined");if("function"!=typeof r)throw new TypeError("predicate must be a function");for(var n=Object(this),t=n.length>>>0,o=arguments[1],e=void 0,i=0;i<t;i++)if(e=n[i],r.call(o,e,i,n))return e})}();



//////////////////
// WEBPACK FOOTER
// ./node_modules/mdn-polyfills/Array.prototype.find.js
// module id = 416
// module chunks = 1